/** Paths that render without the portal login redirect. */
export const PUBLIC_EMBED_PATHS = ["/current-wash-locations-map"];

/**
 * Sites allowed to embed those paths.
 * Override at build time with REACT_APP_PUBLIC_EMBED_ORIGINS (comma-separated origins).
 * Keep customHttp.yml frame-ancestors in sync with this list.
 */
const DEFAULT_PUBLIC_EMBED_ORIGINS = [
  "https://priorityonewashclub.com",
  "https://www.priorityonewashclub.com",
  "https://priorityonewashclub.co.nz",
  "https://www.priorityonewashclub.co.nz",
  "https://assurescratchanddent.com.au",
  "https://www.assurescratchanddent.com.au",
];

/** CSP frame-ancestors for Amplify customHttp.yml (keep in sync). */
export function frameAncestorsCspDirective(origins = getPublicEmbedOrigins()) {
  return `frame-ancestors 'self' ${origins.join(" ")}`;
}

export function getPublicEmbedOrigins() {
  const raw = process.env.REACT_APP_PUBLIC_EMBED_ORIGINS;
  if (raw == null || String(raw).trim() === "") {
    return DEFAULT_PUBLIC_EMBED_ORIGINS;
  }
  return String(raw)
    .split(",")
    .map((origin) => origin.trim())
    .filter(Boolean);
}

export function isPublicEmbedPath(pathname) {
  const path = String(pathname || "/").split("?")[0].replace(/\/+$/, "") || "/";
  return PUBLIC_EMBED_PATHS.includes(path);
}

/**
 * Direct visits are public. A framed page is allowed when the parent origin is
 * on the list. An empty referrer is allowed here because frame-ancestors is the
 * enforcement that does not depend on the parent sending a referrer.
 */
export function isAllowedEmbedParent({ framed, referrer, origins = getPublicEmbedOrigins() }) {
  if (!framed) return true;
  if (!referrer) return true;
  try {
    return origins.includes(new URL(referrer).origin);
  } catch (_error) {
    return false;
  }
}

export function isCurrentEmbedAllowed(windowObject = typeof window !== "undefined" ? window : undefined) {
  if (!windowObject) return true;
  let framed = false;
  try {
    framed = windowObject.self !== windowObject.top;
  } catch (_error) {
    framed = true;
  }
  return isAllowedEmbedParent({
    framed,
    referrer: windowObject.document?.referrer || ""
  });
}
